"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true if the request is explicit logon request, false otherwise.
 */
function isExplicitLogonRequest(requestOptions) {
    return requestOptions && requestOptions.headers && requestOptions.headers.get('X-OWA-ExplicitLogonUser') != null;
}
exports.default = isExplicitLogonRequest;
